//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import UserForm from 'app_components/modules/admin/user/userForm'
import UserSkeleton from './userSkeleton'
//@end

// @import hooks
// @end

// @import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { IUserListItem, UserFormInputs } from 'app_types/admin/user/userTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../userScreen.scss'

// @ADD Component types
interface IUserScreenLayoutProps {
  userList: IUserListItem[]
  status: null | 'loading' | 'error'
  add: boolean
  edit: boolean
  view: boolean
  editData: any
  selectedRow: null | string
  pagination: IPagination
  addUser: any
  updateUser: any
  showAddUserForm: (add: boolean) => void
  showEditUserForm: (edit: boolean, editData?: any) => void
  onViewerRow: (view: boolean, editData?: any) => void
  onPageChange: (page: number) => void
  onRowClick: (row: any) => void
  removeUser: (userId: string) => void
  onSearch: (search: string) => void
  showModal: (modal: boolean) => void
  role?: string | undefined
  searchFormInputs?: any
  show_inputs?: UserFormInputs[]
  editabled_inputs?: UserFormInputs[]
}

const UserScreenLayout: React.FC<IUserScreenLayoutProps> = (props) => {

  const { t } = useTranslation()

  const role_type = (props.role) ? props.role : 'default'


  return(
    <AppContainer>
      <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t(`components.breadcrumb.users_${role_type}`)}`]} />

        <div className='user-screen'>

          {props.status === 'loading' && (
            <UserSkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t(`screens.users_${role_type}.title`)}</h2>

              <DataTableComponent
                data={props.userList}
                headerKeys={[
                  '',
                  `${t('components.dataTable.headers.first_name')}`,
                  `${t('components.dataTable.headers.last_name')}`,
                  `${t('components.dataTable.headers.user_name')}`,
                ]}
                keys={['profile.avatar', 'profile.first_name', 'profile.last_name', 'username']}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[
                  { name: `${t('components.dataTable.details.email')}`, key: 'profile.email' },
                ]}
                onSearch={props.onSearch}
                onAddRow={props.showAddUserForm}
                onClickRow={props.onRowClick}
                onRemoveRow={props.removeUser}
                onPageChange={props.onPageChange}
                onEditRow={props.showEditUserForm}
                onViewerRow={props.onViewerRow}
                onModal={props.showModal}
                searchFormInputs={props.searchFormInputs}
              />
            </>
          )}

          {props.add && (
            <div className="user-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                <h2 className="form-title">
                  {t(`screens.users_${role_type}.add_layout.title_page`)}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showAddUserForm(false)}>
                  {t("buttons.back")}
                </button>
              </div>
              <UserForm
                onHandleSubmit={props.addUser}
                viewer={false}
                role={props.role}
                show_inputs={props.show_inputs || undefined}
                editabled_inputs={props.editabled_inputs || undefined}
              />
            </div>
          )}

          {(props.edit || props.view) && props.editData && (
            <div className="user-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                {props.edit && (
                  <>
                    <h2 className="form-title">
                      {t(`screens.users_${role_type}.edit_layout.title_page`, {user: `${props.editData?.profile?.first_name} ${props.editData?.profile?.last_name}`})}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showEditUserForm(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
                {props.view && (
                  <>
                    <h2 className="form-title">
                      {t(`screens.users_${role_type}.view_layout.title_page`)}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.onViewerRow(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
              </div>
              <UserForm
                editData={props.editData}
                onHandleSubmit={props.updateUser}
                viewer={props.view}
                role={props.role}
                show_inputs={props.show_inputs || undefined}
                editabled_inputs={props.editabled_inputs || undefined}
                key={props?.editData?.details?._id}
              />
            </div>
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default UserScreenLayout
